module.exports = __webpack_public_path__ + "static/img/login_bg.0c732ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_bg.png
// module id = 977
// module chunks = 3